/* eslint no-console: 0 */
import "babel-polyfill";
import "reflect-metadata";
import "rizzo-next/src/components/analytics";
import rizzo from "rizzo-next/dist/rizzo";
import GlobalHeader from "rizzo-next/dist/components/header";
import GlobalFooter from "rizzo-next/dist/components/footer";
import FastClick from "fastclick";
import "rizzo-next/dist/core/utils/preload";
import "rizzo-next/dist/core/utils/detect_swipe";
import "rizzo-next/dist/core/event_tracker";
import "rizzo-next/dist/components/ads";
import "rizzo-next/dist/components/svg_icons";
import CookieUtil from "rizzo-next/dist/core/cookie_util";
import postal from "postal/lib/postal.lodash";
import LoginManager from "rizzo-next/dist/components/login/login_manager";
import Alert from "rizzo-next/dist/components/alert";
import "rc-slider/assets/index.css";
import "rizzo-next/src/components/image_gallery/image_gallery.scss";
import $ from "jquery";
import "./common.scss";

if (typeof window !== "undefined") {
  window.$ = $;
}

// Create LP namespace if it isn"t there already
window.lp = window.lp || {};
window.lp.ads = window.lp.ads || {};
window.lp.loginManager = new LoginManager();

rizzo.renderComponent(GlobalHeader, ".lp-global-header");
rizzo.renderComponent(GlobalFooter, ".lp-global-footer");

if (process.env.NODE_ENV === "production") {
  /* eslint-disable */
  require("trackjs");
  /* eslint-enable */
}

FastClick.attach(document.body);

const cookie = new CookieUtil();
cookie.setCookie("destinations-next-cookie", true, 14);

// Show cookie notification for EU users
if (cookie.getCookie("lpCurrency") && cookie.getCookie("lpCurrency").match(/GBP|EUR/)) {
  rizzo.renderComponent(Alert, {
    el: "body",
    alert: {
      type: "default",
      text: "We use cookies to improve your experience on our website."
        + "You can update your settings",
      link_text: "here",
      link: "http://www.lonelyplanet.com/legal/cookies",
    },
  });
}

if (process.env.NODE_ENV === "development") {
  postal.addWireTap((data, envelope) => {
    console.log(JSON.stringify(envelope));
  });
}

$.support.cors = true;

window.jQuery = $;
window.$ = $;
$.detectSwipe.preventDefault = false;



// WEBPACK FOOTER //
// ./assets/common.js